import { getSocket } from "@/utils/socket";

let socket: any = null;

export function useSocketListeners(
  parentCallSid: any,
  currentCallSid: any,
  lastCallSid: any,
  to: any,
  loadChannels: () => Promise<void>
) {
  function shouldUpdateParentCallSid(newParentCallSid: string, eventData: any): boolean {
    if (!parentCallSid.value) {
      return true;
    }

    if (
      newParentCallSid === currentCallSid.value ||
      newParentCallSid === lastCallSid.value ||
      (eventData.to && eventData.to === to.value?.replace(/\s+/g, ""))
    ) {
      return true;
    }

    return false;
  }

  function setupSocketListeners() {
    try {
      socket = getSocket();

      socket.on("call:start", (data: any) => {
        const newParentCallSid = data.parentCallSid || data.callSid;
        if (newParentCallSid) {
          if (!parentCallSid.value || shouldUpdateParentCallSid(newParentCallSid, data)) {
            parentCallSid.value = newParentCallSid;
          }
        }
      });

      socket.on("call:status", (data: any) => {
        const newParentCallSid = data.parentCallSid || data.callSid;
        if (newParentCallSid && data.status === "ringing") {
          if (!parentCallSid.value || shouldUpdateParentCallSid(newParentCallSid, data)) {
            parentCallSid.value = newParentCallSid;
          }
        }
      });

      socket.on("call:ringing", (data: any) => {
        const newParentCallSid = data.parentCallSid || data.callSid;
        if (newParentCallSid) {
          if (!parentCallSid.value || shouldUpdateParentCallSid(newParentCallSid, data)) {
            parentCallSid.value = newParentCallSid;
          }
        }
      });

      socket.on("unipile:account:status_changed", () => {
        loadChannels();
      });
    } catch (error) {
      console.error("Failed to set up Socket.IO listeners:", error);
    }
  }

  function cleanupSocketListeners() {
    if (socket) {
      try {
        socket.off("call:start");
        socket.off("call:status");
        socket.off("call:ringing");
        socket.off("unipile:account:status_changed");
      } catch (error) {
        console.error("Error cleaning up Socket.IO listeners:", error);
      }
    }
  }

  return {
    setupSocketListeners,
    cleanupSocketListeners,
    shouldUpdateParentCallSid,
  };
}
